import AssignmentIcon from "@mui/icons-material/Assignment";
import CircleIcon from "@mui/icons-material/Circle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Rotate90DegreesCwIcon from "@mui/icons-material/Rotate90DegreesCw";
import {
  Box,
  Grid,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { useEffect, useState } from "react";
import {
  RecordContextProvider,
  useGetList,
  useRecordContext,
} from "react-admin";
import HmPageHeaderTitle from "../../unit/HmPageHeaderTitle";
import ClosingCreated from "../historys/ClosingCreated";
import ClosingReceived from "../historys/ClosingReceived";
import DefaultLog from "../historys/DefaultLog";
import FinalReview from "../historys/FinalReview";
import Funding from "../historys/Funding";
import Holdlog from "../historys/Hold";
import HoldToDeclined from "../historys/HoldToDeclined";
import HoldToResume from "../historys/HoldToResume";
import HoldToResumeDecline from "../historys/HoldToResumeDecline";
import InitialLog from "../historys/InitialLog";
import InitialReview from "../historys/InitialReview";
import LoanUpdateStatus from "../historys/LoanUpdateStatus";
import Movelog from "../historys/Movelog";
import NewApplicationInfo from "../historys/NewApplicationInfo";
import { Print } from "@mui/icons-material";
import AcceptLog from "../historys/AcceptLog";
const MainSection = styled("article")({
  //   paddingTop: '64px', // 头部高度
  paddingTop: "10px",
  paddingBottom: "48px", // 底部高度
  height: `calc(100vh - 120px - 60px - 110px - 50px)`, // 视口高度减去头部和底部的高度
  overflowY: "auto", // 可滚动
  backgroundColor: "#fff",
});
const ApplicationHistory = ({ ...props }) => {
  const [historyRecords, setHistoryRecords] = useState<any[]>([]);
  const paramAppId = props.appId;
  let appId = "";
  let record = props.record;

  //当record 变化再加载数据
  // useEffect(() => {
  //   console.log("History record 变化再加载数据", record);
  // }, [record]);

  const isMounted = React.useRef(false);
  const renderCountRef = React.useRef(0);
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      renderCountRef.current += 1;
      // console.log("history 组件已重新渲染", renderCountRef.current, "次");
    }
  });

  if (paramAppId != undefined && record != undefined) {
    appId = paramAppId;
  } else {
    record = useRecordContext();
    if (record) {
      appId = record.id;
    }
  }

  //const record = useRecordContext();
  if (!record || record === undefined) {
    return <Typography>Loading history...</Typography>;
  }
  const reqUrl = "applications/history/" + appId;
  if (appId === "" || appId === undefined) {
    return <Typography>Loading history...</Typography>;
  }
  const { data, total, error } = useGetList(reqUrl);

  useEffect(() => {
    if (data) {
      setHistoryRecords(data);
    }
  }, [appId, data]);

  if (error) {
    return <Typography color="error">Error loading data</Typography>;
  }
  // if (!total) {
  //   return <Typography>No Data</Typography>;
  // }

  const totalLogs = total;
  const handlePrintHistory = () => {
    const style = document.createElement("style");
    style.innerHTML = `
    @media print {
      body * {
        visibility: hidden;
      }
      [class*="printBody-history-${appId}"],
      [class*="printBody-history-${appId}"] * {
        visibility: visible;
        overflow: visible !important;
        max-height: none !important;
        height: auto !important;
      }
      [class*="printBody-history-${appId}"]{
        position: absolute;
        left: 0;
        top: 0;
        width:100% !important;
      }
    }
  `;
    document.head.appendChild(style);

    window.print();
    setTimeout(() => {
      document.head.removeChild(style);
    }, 100);
  };
  return (
    <Box>
      {/* <ApplicationHistoryHeader record={record} /> */}
      <Grid container sx={{ width: "100%", p: 1 }}>
        <HmPageHeaderTitle title={"Review History"} />
        {/* Right Icon Print only left Menu */}
        {/* <Print
          sx={{
            ml: "auto",
            cursor: "pointer",
            color: "#1976d2",
            "&:hover": { color: "#0b4f94ff" },
          }}
          onClick={handlePrintHistory}
        /> */}
      </Grid>
      {record?.sStatus == "Incomplete" && (
        <Typography sx={{ mt: 2, ml: 1 }}>
          No History for Incomplete Application
        </Typography>
      )}
      {record?.sStatus != "Incomplete" && (
        <MainSection
          id="mainsection-application-history"
          className={`printBody-history-${appId} app-summary-bodysection`}
        >
          <div>
            <CircleIcon sx={{ fontSize: "15px", marginLeft: "18px" }} />
          </div>
          {historyRecords && (
            <Timeline
              key={`timeline_` + appId}
              logs={historyRecords}
              appId={parseInt(appId)}
              record={record}
            />
          )}
          <div>
            <ExpandMoreIcon sx={{ fontSize: "25px", marginLeft: "12px" }} />
          </div>
        </MainSection>
      )}
    </Box>
  );
};
const LogTitle = ({ ...props }) => {
  const { status, execstatus, other, option } = props;
  if (!status) return null;
  let titleStatus = status;
  if (status == "Execution" && execstatus != "Closing Dos Received") {
    // titleStatus = "Record activities on the To Notify Applicant page";
    titleStatus = "To Notify";
  } else if (status == "Execution" && execstatus == "Closing Dos Received") {
    // titleStatus = "Finalization";
    titleStatus = "Closing";
  } else if (status == "New") {
    titleStatus = "New";
  } else if (status == "toInitiate") {
    titleStatus = "Application Check";
  } else if (status == "Hold") {
    titleStatus = "Move to Hold";
  } else if (status == "Final Review") {
    titleStatus = "Final Review " + other;
  } else if (status == "Loan Update Status") {
    titleStatus = option;
  } else if (status == "Funding") {
    // titleStatus = "Completion";
    titleStatus = "Disbursement";
  } else if (status == "Countered to Approved") {
    titleStatus = "Countered";
  }

  return <>{titleStatus}</>;
};

const Timeline = ({ ...props }) => {
  const logs = props.logs;
  const appId = props.appId;
  const record = props.record;
  // console.log("logs====>", logs);

  const LogStep = ({ log, index }: { log: any; index: number }) => {
    if (log.sStatus == "Application Check") {
      //Application Check same to toInitiate
      return null;
    }
    // if (log.sStatus == "toInitiate") {
    //   return null;
    // }
    return (
      <Step key={`${index}-${log.id}-${log.sOper}`} expanded active completed>
        <RecordContextProvider value={log}>
          <StepLabel
            key={`steplabel_` + appId + `_` + log.id}
            icon={
              log.type == "movelog" ? (
                <Rotate90DegreesCwIcon />
              ) : (
                <AssignmentIcon />
              )
            }
          >
            <LogTitle
              status={log.sStatus}
              execstatus={log.sExecuteStatus}
              other={log.sFinalReviewStatus}
              option={log.sOption}
            />
          </StepLabel>
          <StepContent key={`stepcontent_` + appId + `_` + log.id}>
            {log.sStatus == "Execution" &&
            log.sExecuteStatus != "Closing Dos Received" ? (
              <ClosingCreated appId={appId} />
            ) : log.sStatus == "Execution" &&
              log.sExecuteStatus == "Closing Dos Received" ? (
              <ClosingReceived appId={appId} />
            ) : log.sStatus == "Funding" ? (
              <Funding appId={appId} />
            ) : log.sStatus == "Initial Review" ? (
              <InitialReview appId={appId} />
            ) : log.sStatus == "Final Review" ? (
              <FinalReview appId={appId} />
            ) : log.sStatus == "Hold" ? (
              <Holdlog appId={appId} />
            ) : log.sStatus == "New" ? (
              <Holdlog appId={appId} />
            ) : log.sStatus == "toInitiate" ? (
              <InitialLog
                appId={appId}
                checkStep={record?.checkStep}
                attrs={record?.attrs}
              />
            ) : log.sStatus == "Hold to Resume" ? (
              <HoldToResume appId={appId} />
            ) : log.sStatus == "Hold to Recommend Decline" ? (
              <HoldToResumeDecline appId={appId} />
            ) : log.sStatus == "Hold to Declined" ? (
              <HoldToDeclined appId={appId} />
            ) : log.sStatus == "Loan Update Status" ? (
              <LoanUpdateStatus appId={appId} />
            ) : log.type == "movelog" ? (
              <Movelog appId={appId} />
            ) : log.sStatus == "Pre-Approved" && log.sDecision == "Accept" ? (
              <AcceptLog />
            ) : log.sStatus == "Countered" && log.sDecision == "Accept" ? (
              <AcceptLog />
            ) : (
              <DefaultLog appId={appId} />
            )}
          </StepContent>
        </RecordContextProvider>
      </Step>
    );
  };
  return (
    <>
      {/* <div>        
        <CircleIcon sx={{ fontSize: "15px", marginLeft: "6px" }} />
      </div> */}
      <Stepper
        key={`stepperHistory_` + appId}
        orientation="vertical"
        sx={{ my: 1, ml: 1.5 }}
      >
        <NewApplicationInfo record={record} />
        {/* <ApplicationCheckInfo record={record} /> */}
        {logs.map((log: any, index: number) => {
          return <LogStep log={log} index={index} key={`logStep_` + index} />;
        })}
      </Stepper>
      {/* <div>          
          <ExpandMoreIcon />
        </div> */}
    </>
  );
};

export default ApplicationHistory;
